import Bullet from "../objects/bullet";
import { bulletType } from "../assets/data/enum";
import Player from "../objects/player";
import Enemy from "../objects/enemy";
import Barrel from "../objects/gunBarrel";



export default class Gun {
    public name: string; // pg -> playerGun, btg -> battleTruckGun, bg -> buggyGun, tg -> tankGun
    public type: bulletType;
    public speed: number;
    public target: Player | Enemy;
    public hitValue: number;
    public parent: Player | Enemy;
    public bullets: Phaser.GameObjects.Group;
    public boundary: {
        l?: number, r?: number, t?: number, b?: number
    };
    // public isAimbot: boolean;

    private _scene: Phaser.Scene;
    private _count: number;
    private _offset;
    private _key: string;
    private _lastFired: number = 0;
    private _rateOfFire: number = 0;
    private _rateOfRounds: number = 0;
    private _lastRound: number = 0;
    private _safetyOff: boolean = false;
    private _targetPosition: Array<number> = [];
    private _targetAngle: number = null;
    private _bulletsFired: number = 0;
    private _roundsRemaining: number = 0;
    private _totalRounds: number;
    private _shoot: Function;
    private _fire: Function;
    private _barrel: Array<Barrel>;
    private _container: Phaser.GameObjects.Container;
    private _shootDelay: number = 0;
    public tag: string;

    private _shootAudio: Phaser.Sound.BaseSound;
    private _splitShootAudio: Phaser.Sound.BaseSound;

    constructor(name: string, key: string, frame: string, count: number, speed: number, type: bulletType, offset: any, parent: Player | Enemy, rounds: number, container: Phaser.GameObjects.Container, target?: Player | Enemy, rateOfFire?: number, rateOfRounds?: number) {
        this.parent = parent;
        this._scene = this.parent.getScene();
        this.tag = frame;
        this._container = container;

        // init vars
        this._count = count;
        this._key = key;
        this.type = type;
        this._rateOfFire = rateOfFire || 100;// depends upon the size of the bullet and is fairly the same for different screen sizes
        this._rateOfRounds = rateOfRounds || 0;
        this.speed = speed;
        this.target = target;
        this.hitValue = window.constants.DATA.hitValue["bullet_" + parent.tag] || 0;

        // create gun bundary, used by bullets to check if they are in screen
        let bullet_image = this._scene.textures.getFrame(key, frame);
        this.boundary = {
            l: -bullet_image.width,
            r: window.constants.BASE_WIDTH + bullet_image.width,
            b: window.constants.BASE_HEIGHT + bullet_image.height,
            t: -bullet_image.height
        }

        this._targetPosition = [];

        if (rounds > 0) {
            this._totalRounds = rounds;
            this._roundsRemaining = rounds;
            this._shoot = this._shootFinite;
        }
        else {
            this._shoot = this._shootInfinite;
        }

        // create bullets
        this.bullets = this._scene.add.group({
            classType: Bullet,
            maxSize: this._count * 30,
            runChildUpdate: true,
            createCallback: this._createBulletCallback.bind(this),
            defaultKey: key
        });

        this.bullets.createMultiple({
            classType: Bullet,
            frame: frame,
            key: key,
            quantity: this._count,
            visible: false,
            active: false,
            setXY: {
                x: this.parent.x,
                y: this.parent.y
            }
        })
        this._offset = offset;
        // craete gun barrel
        this._createBarrel(offset);
        this._shootAudio = this._scene.sound.add("shoot", {
            loop: false,
            volume: (window.constants["VOLUME"] * 0.15)
        });
        if(this.parent.tag == "player") {
            this._splitShootAudio = this._scene.sound.add("split_shooter", {
                loop: true,
                volume: (window.constants["VOLUME"] * 0.2)
            });
        }

        //this offset will be used for the bullet spawn position
        // this._offset = [
        //     {
        //         x: offset.x,
        //         y: offset.y - (this._barrel[0].height)
        //     },
        //     {
        //         x: offset.x - 30,
        //         y: offset.y - (this._barrel[0].height)
        //     },
        //     {
        //         x: offset.x + 30,
        //         y: offset.y - (this._barrel[0].height)
        //     }
        // ];

        this.setGunType(type);
        this.stop();
    }

    private _createBarrel(offset) {
        let gunName = 'gun_'+(this.parent.tag);
        // console.log(gunName);
        if (this.type == bulletType.player || this.type == bulletType.split_shooter) {
            let recoilLimit;
            if(this.parent instanceof Player){
                recoilLimit =  Math.floor(this.parent.car.height * 0.065);
            }
            this._barrel = [
                new Barrel(this._scene, offset.x, offset.y, "assets", gunName, true, this.parent, offset, recoilLimit),
                new Barrel(this._scene, offset.x, offset.y, "assets", gunName, true, this.parent, offset, recoilLimit),
                new Barrel(this._scene, offset.x, offset.y, "assets", gunName, true, this.parent, offset, recoilLimit)
            ];
            if (this.parent instanceof Player) {
                this.parent.add(this._barrel[0]);
                this.parent.add(this._barrel[1]);
                this.parent.add(this._barrel[2]);
            }
            this._barrel[1].angle = -25;
            this._barrel[2].angle = 25;
            this._handleBarrelVisibility(bulletType.split_shooter, false, false);
        }
        else {
            this._barrel = [new Barrel(this._scene, offset.x, offset.y, "assets", gunName, false, this.parent, offset)];
            this._container.add(this._barrel[0]);
            this._handleBarrelVisibility(this.type, false, false);
        }
    }

    private _createBulletCallback(bullet: Bullet) {
        this._container.add(bullet);
        let length = this.bullets.getLength();
        bullet.setProperties(this, length);
    }

    private _reload() {
        this._roundsRemaining = this._totalRounds;
        this._bulletsFired = 0;
    }

    private _singleFire(targetPos, targetAngle) {
        let bullet = this.bullets.getFirstDead(true, this.parent.x, this.parent.y, "assets", this.tag);
        if (bullet) {
            if(targetAngle != null) {
                let x = this.parent.x + (this._barrel[0].height * Math.cos(targetAngle)), y = this.parent.y + (this._barrel[0].height * Math.sin(targetAngle))
                bullet.reset(x, y);
            }
            else {
                bullet.reset(this.parent.x + this._offset.bx[0], this.parent.y + this._offset.by[0]);
            }
            bullet.setBulletType();
            if (targetPos[0] != undefined) {
                if (targetPos[1] > (this.parent.y + (this.parent.height / 2))) {
                    this._barrel[0].turn(this._targetAngle + (Math.PI * 0.5));
                    bullet.move(0, targetPos[0], targetPos[1]);
                }
            }
            else {
                bullet.move(0);
            }
            this._shootAudio.play();
        }
    }

    private _tripleFire() {
        let bullet1 = this.bullets.getFirstDead(true, this.parent.x, this.parent.y, "assets", this.tag);
        bullet1.reset(this.parent.x + this._offset.bx[1], this.parent.y + this._offset.by[1]);
        bullet1.setBulletType();
        bullet1.move(255);

        let bullet2 = this.bullets.getFirstDead(true, this.parent.x, this.parent.y, "assets", this.tag);
        bullet2.reset(this.parent.x + this._offset.bx[0], this.parent.y + this._offset.by[0]);
        bullet2.setBulletType();
        bullet2.move(270);

        let bullet3 = this.bullets.getFirstDead(true, this.parent.x, this.parent.y, "assets", this.tag);
        bullet3.reset(this.parent.x + this._offset.bx[2], this.parent.y + this._offset.by[2]);
        bullet3.setBulletType();
        bullet3.move(285);
    }

    private _takeAim() {
        this._targetAngle = -1;
        if (this.target) {
            this._targetAngle = Math.atan2((this.target.y - this.parent.y), (this.target.x - this.parent.x));
            this._targetPosition = [this.target.x, this.target.y];
        }
    }

    private _shootInfinite(time, dt) {
        if (this._bulletsFired < this._count) {
            // this._lastFired += dt;
            if (((time - this._lastFired) * 0.001) > this._rateOfFire) {
                // console.log(this.parent.tag);
                // if(this.parent.tag == "player"){
                // console.log("p");
                // }
                this._lastFired = time;
                this._fire(this._targetPosition, this._targetAngle);
                this._bulletsFired++;
            }
        }
        else {
            // this._lastRound += dt;
            if (((time - this._lastRound) * 0.001) > this._rateOfRounds) {
                this._lastRound = time;
                this._bulletsFired = 0;
                if (this.target) {
                    this._takeAim();
                }
            }
        }
    }

    private _shootFinite(time, dt) {
        if (this._roundsRemaining) {
            if (this._bulletsFired < this._count) {
                // this._lastFired += dt;
                if (((time - this._lastFired) * 0.001) > this._rateOfFire) {
                    this._lastFired = time;
                    this._fire(this._targetPosition, this._targetAngle);
                    this._bulletsFired++;
                }
            }
            else {
                // this._lastRound += dt;
                if (((time - this._lastRound) * 0.001) > this._rateOfRounds) {
                    this._lastRound = time;
                    this._roundsRemaining--;
                    this._bulletsFired = 0;
                    this._takeAim();
                }
            }
        }
    }

    private _handleBarrelVisibility(type, show: boolean, recoil:boolean) {
        recoil = (recoil != undefined || recoil != null)? recoil : false;
        // console.log("Barrel Visibility = "+show+", recoil = "+recoil);
        if (show) {
            if (type == bulletType.split_shooter) {
                this._barrel[0].start(recoil);
                this._barrel[1].start(recoil);
                this._barrel[2].start(recoil);
            } else {
                this._barrel[0].start(recoil);
            }
        } else {
            if (type == bulletType.split_shooter) {
                this._barrel[0].stop();
                this._barrel[1].stop();
                this._barrel[2].stop();
            } else {
                this._barrel[0].stop();
            }
        }
    }

    private _stopBullets() {
        let bullets =  this.bullets.getChildren();
        for(let i=0, length = bullets.length; i< length; i++) {
            if(bullets[i].active) {
                bullets[i].stop();
            }
        }
    }

    public update(time, dt) {
        
        this._barrel[0].update(time, dt);

        if (this.type == bulletType.split_shooter) {
            this._barrel[1].update(time, dt);
            this._barrel[2].update(time, dt);
        }
        
        if (this._safetyOff) {
            this._shoot(time, dt);
        }else if(this._shootDelay > 0){
            this.shoot(this.type, this._shootDelay - (dt))
        }
    }

    public shoot(type, time) {
        this.type = type;
        if(time <= 0) {
            if (!this._safetyOff) {
                this._safetyOff = true;
                this._reload();
                this._takeAim();
                this.setGunType(type);
                this._lastRound = this._scene.time.now;
                this._lastFired = 0;
            }
        }
        else {
            this._shootDelay = time;
        }
    }

    public showBarrel() {
        this._handleBarrelVisibility(this.type, true, false);
    }

    public stop(barrelVisibility?: boolean, stopBullets?: boolean) {
        this._handleBarrelVisibility(this.type, !!barrelVisibility, false);
        this.reset(stopBullets);        
    }

    public reset(stopBullets?: boolean) {
        if(!!stopBullets) {
            this._stopBullets();
        }
        this._safetyOff = false;
        if (this.type == bulletType.split_shooter) {
            this._barrel[0].stop();
            this._barrel[1].stop();
            this._barrel[2].stop();
        } else {
            this._barrel[0].stop();
        }
        // console.log("Stop barrel recoil");
    }

    public setGunType(type: bulletType) {
        this._handleBarrelVisibility(this.type, false, false); // hide the previous type of gun barrel used
        this.type = type;
        switch (type) {
            case bulletType.player:
                this._targetAngle = null;
                this._fire = this._singleFire;
                this.speed = Math.abs(this.speed) * -1;
                this._splitShootAudio.stop();
                break;
            case bulletType.buggy:
                this._fire = this._singleFire;
                break;
            case bulletType.split_shooter:
                this._fire = this._tripleFire;
                this.speed = Math.abs(this.speed);
                this._splitShootAudio.play();
                break;
        }
        this._handleBarrelVisibility(this.type, true, true); // show the new type of gun barrel used
    }
} 
